module.exports = __webpack_public_path__ + "img/green_038.74743564.png";